import { BranchDetailsIdDataInput } from './branch-details-id-data-input.model';


export class SelectTourByCompanyIdBranchIdInput implements ISelectTourByCompanyIdBranchIdInput {
    /** The auto-generated id of the company details master */
    companyDetailId!: number;
    branchDetailsIdData!: BranchDetailsIdDataInput[];

    constructor(data?: ISelectTourByCompanyIdBranchIdInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyDetailId = _data["companyDetailId"];
            if (Array.isArray(_data["branchDetailsIdData"])) {
                this.branchDetailsIdData = [] as any;
                for (let item of _data["branchDetailsIdData"])
                    this.branchDetailsIdData!.push(BranchDetailsIdDataInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SelectTourByCompanyIdBranchIdInput {
        data = typeof data === 'object' ? data : {};
        let result = new SelectTourByCompanyIdBranchIdInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyDetailId"] = this.companyDetailId;
        if (Array.isArray(this.branchDetailsIdData)) {
            data["branchDetailsIdData"] = [];
            for (let item of this.branchDetailsIdData)
                data["branchDetailsIdData"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISelectTourByCompanyIdBranchIdInput {
    /** The auto-generated id of the company details master */
    companyDetailId: number;
    branchDetailsIdData: BranchDetailsIdDataInput[];
}

